"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _reactTable = require("@tanstack/react-table");
var _footer = require("./footer.style");
const Footer = _ref => {
  let {
    footerData,
    stickyFooter
  } = _ref;
  const handleTextAlign = header => {
    if ((header === null || header === void 0 ? void 0 : header.colSpan) > 1) {
      return 'center';
    }
    if ((header === null || header === void 0 ? void 0 : header.column.columnDef.type) === 'number') {
      return 'right';
    }
    return 'left';
  };
  return (0, _jsxRuntime.jsx)(_footer.Components.TFoot, {
    children: footerData && footerData.map(footerGroup => (0, _jsxRuntime.jsx)("tr", {
      children: footerGroup.headers.map(header => header.column.columnDef.footer && (0, _jsxRuntime.jsx)(_footer.Components.Td, (0, _extends2["default"])({
        alignText: handleTextAlign(header),
        colSpan: header.column.columnDef.footerSpan,
        stickyColumn: stickyFooter && header.column.columnDef.meta && header.column.columnDef.meta.stickyColumn,
        stickyFooter: stickyFooter
      }, {
        children: header.isPlaceholder ? null : header.column.columnDef.footer ? (0, _reactTable.flexRender)(header.column.columnDef.footer, header.getContext()) : null
      }), header.id))
    }, footerGroup.id))
  });
};
var _default = exports["default"] = Footer;